<template>
  <div
  
    class="video-player-back-div"
    @click="closeVideoPlayer($event)"
    id="video-player-back-div"
  >
    <div class="video-player-box">
      <div class="video-player">
        <video autoplay controls>
          <source
            :src="galleryItem?.file[0]"
            type="video/mp4"
          />
          Your browser does not support the video tag.
        </video>
      </div>
      <div class="video-info">
        <h2>
          {{ galleryItem?.title }}
          <likeButton
            v-if="galleryItem?.like"
            :likeNumber="galleryItem?.like"
          ></likeButton>
        </h2>
        <div v-if="galleryItem?.description" class="description-box">
          <p>{{ galleryItem?.description }}</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import likeButton from "@/components/likeButton/index.vue";

export default {
  name: "galleryVideoPlayer",
  props: {
    galleryItem: Object,
  },
  components: {
    likeButton,
  },
  methods: {
    closeVideoPlayer(e) {
      if (e.target.id === "video-player-back-div") {
        this.$emit("selectedvideo", null);
      }
    },
  },
};
</script>

<style lang="css" scoped>
@import url(@/assets/style/components/galleryVideoPlayer/galleryVideoPlayer.css);
</style>